import React from "react";
import { useTranslation } from "react-i18next";
import caseIcon from "@/assets/case.svg";
import { FixButton } from "../fix-button";
import styles from "./b2b-button.module.scss";

const B2bButton: React.FC = () => {
  const { t } = useTranslation();
  return (
    <FixButton
      variant="primary"
      size="small"
      href="/business-v2"
      target="_blank"
      className={styles.button}
      prefix={<img src={caseIcon} alt="go to b2b portal" />}
    >
      <span>{t("basyf8oib4rn8934.b2b-portal", "B2B Portal")}</span>
    </FixButton>
  );
};

export default B2bButton;
